import './styles/global.css';
import '@arpm/ui/fonts.css';
import '@arpm/ui/tokens.css';
import '@arpm/ui/styles';

import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { initTheme } from './composables/useTheme.js';
import { i18n } from './i18n/index.js';
import { router } from './router/index.js';
import { useAuthStore } from './stores/auth.js';

async function bootstrap() {
  // Тема ставится до монтирования — иначе на первом кадре мигнёт светлым.
  initTheme();

  const app = createApp(App);
  app.use(createPinia());
  app.use(i18n);
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          retry: 1,
          staleTime: 30_000,
          refetchOnWindowFocus: false,
        },
      },
    },
  });

  // Сессию восстанавливаем до роутера, чтобы навигационный гвард видел
  // настоящее состояние авторизации, а не «ещё не загрузились».
  const auth = useAuthStore();
  await auth.initialize();

  app.use(router);
  app.mount('#app');
}

bootstrap().catch((err) => {
   
  console.error('Не удалось загрузить events-web', err);
});
